// @flow
import { setUserNeedsAppUpdate } from '../actions/appupdate'
import { setUnreadNotificationsCount } from 'actions/mycourses'
import { setUnreadFeedbackCount } from 'actions/myquests'
import { showModal } from '../actions/_modal'

export function getUser(users: Array<Object>, userId: number): ?Object {
  return users.find(function (u) {
    return parseInt(u.id) === parseInt(userId)
  })
}

export function getUserName(users: Array<Object>, userId: number): string {
  const user = getUser(users, userId)
  return user ? user.name : ''
}

export function studentSectionTransferCallback(data) {
  const { dispatch, user } = this
  if (data.user_ids.includes(user.id)) {
    dispatch(setUserNeedsAppUpdate())
  }
}

export function updateUnreadNotificationsCallback({
  user_ids,
  current_sections_unread_notifications_count,
  active_quests_with_unread_notifications_count
}) {
  const { dispatch, user } = this
  if (user_ids.includes(user.id)) {
    dispatch(
      setUnreadNotificationsCount(current_sections_unread_notifications_count)
    )
    dispatch(
      setUnreadFeedbackCount(active_quests_with_unread_notifications_count)
    )
  }
}

export function closeCourseSection(data) {
  const { dispatch, user, courses, isMentor, pastCourses, manifest } = this
  const courseSection = courses.find(
    c => c.course_section.id === data.course_section.id
  )

  const gradeLevels = []

  manifest.data !== null &&
    Object.values(manifest.data.grade_levels).forEach((key, index) => {
      gradeLevels.push({
        id: Object.values(manifest.data.grade_levels)[index].number,
        abbreviation: Object.values(manifest.data.grade_levels)[index]
          .abbreviation,
        name: Object.values(manifest.data.grade_levels)[index].name,
        sort: Object.values(manifest.data.grade_levels)[index].sort_order
      })
    })

  const getGradeLevel = () =>
    gradeLevels.find(gl => gl.id === courseSection.master_course.grade_level_id)

  if (
    data.user_ids.includes(user.id) &&
    data.course_section.id === courseSection.course_section.id
  ) {
    dispatch(
      showModal('CLOSE_JOURNEY_SECTION_NOTIFICATION', {
        courseSection: courseSection,
        grade: getGradeLevel().abbreviation,
        data,
        isMentor,
        courses,
        pastCourses,
        location: window.location,
        userId: user.id
      })
    )
  }
}
